import React from "react";
import { StyleSheet, View, Text } from "react-native";
import Animated from "react-native-reanimated";
import * as Animatable from "react-native-animatable";
import Colors from "@microdoing/shared/constants/Colors";
import { connect } from "react-redux";
import { getUserTimezone } from "@microdoing/shared/services/user/selectors";
import {
  getCampaignName,
  getCampaignStartDate,
} from "@microdoing/shared/services/userCampaign/selectors";
import { CardButton } from "app/components/common";
import i18n from "@microdoing/shared/i18n";
import {
  heightPercentageToDP,
  widthPercentageToDP,
} from "react-native-responsive-screen";
import { getLanguage } from "@microdoing/shared/services/profileSettings/selectors";
import ActionIcon from "../SelectAction/ActionIcon";
import selectLanguage from "@microdoing/shared/utils/selectLanguage";
import displayNextActiveDay from "@microdoing/shared/utils/displayNextActiveDay";
import theme from "app/Theme/Theme";

const MARGIN_LEFT = widthPercentageToDP("15%");
const BUTTON_WIDTH = 240;

const styles = StyleSheet.create({
  space: {
    maxHeight: heightPercentageToDP("15%"),
    flex: 1,
  },
  main: {
    zIndex: 1,
    position: "relative",
    flex: 4,
    width: "100%",
    backgroundColor: Colors.whiteGrey,
    flexDirection: "column",
  },
  bottomIndicator: {
    marginTop: 25,
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  hello: {
    ...theme.title["l7-bold"],
    width: "100%",
    textAlign: "left",
    paddingRight: 15,
    color: theme.colors["brand.500"],
  },
  subHello: {
    ...theme.title["l7-bold"],
    width: "100%",
    textAlign: "left",
    paddingRight: 12,
    color: theme.colors["neutral.900"],
    marginTop: 12,
  },
  explanation: {
    width: "100%",
    maxWidth: BUTTON_WIDTH,
    ...theme.title["l7-semibold"],
    marginTop: 20,
  },
  cardButton: {
    width: BUTTON_WIDTH,
    height: 50,
  },
  cardButtonText: {
    fontWeight: "600",
    fontSize: 16,
  },
  icon: {
    marginRight: 8,
  },
  animation: {},
  campaignName: {
    color: theme.colors["brand.500"],
    ...theme.title["l7-bold"],
  },
  textView: {
    marginLeft: MARGIN_LEFT,
  },
});

const NotStartedCampaign = ({
  firstName,
  campaignName = {},
  language,
  startDate,
  timezone,
}) => {
  return (
    <>
      <View style={styles.space} />
      <View style={styles.main}>
        <Animatable.View useNativeDriver animation="fadeInUp">
          <Animated.View useNativeDriver style={styles.textView}>
            <Text style={styles.hello}>
              {i18n.t("select-action-hello", { firstName })}
            </Text>
            <Text style={styles.subHello}>
              {i18n.t("select-action-sub-hello")}
            </Text>
            <Text style={styles.explanation}>
              {i18n.t("your-campaign")}
              <Text style={styles.campaignName}>
                {selectLanguage({ text: campaignName, language })}
              </Text>
              <Text>
                {i18n.t("will-start-in", {
                  days: displayNextActiveDay({ nextDate: startDate, timezone }),
                })}
              </Text>
            </Text>
            <View style={styles.bottomIndicator}>
              <CardButton
                isDisabled={true}
                Icon={<ActionIcon style={styles.icon} />}
                textPropStyle={styles.cardButtonText}
                buttonPropStyle={styles.cardButton}
                text={i18n.t("see-challenges")}
                onPress={null}
              />
            </View>
          </Animated.View>
        </Animatable.View>
      </View>
    </>
  );
};

const mapStateToProps = state => {
  return {
    language: getLanguage(state),
    startDate: getCampaignStartDate(state),
    timezone: getUserTimezone(state),
    firstName: state.user.firstName,
    campaignName: getCampaignName(state),
  };
};

export default connect(mapStateToProps, {})(NotStartedCampaign);
